import Service from "./Service";
import {isEmpty} from 'lodash';
const baseurl = '/api/asignacion-areas-detalle';
export default {
    index() {
        return Service.get(`${baseurl}/`);
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    async list(id,search = '',pagination = {}) {
        
        let url = `${baseurl}/listar/${id}?`;

        url += search !== '' ? `s=${search}` : '';

        url += (!isEmpty(pagination))
            ? `&paginate=true&per_page=${pagination.per_page}&page=${pagination.page}`
            : '';

        return Service.get(url);
    },

}